import { Node, mergeAttributes } from "@tiptap/core";

export const LAYOUTS: { label: string; ratios: number[] }[] = [
  { label: "1/1", ratios: [1, 1] },
  { label: "1/2", ratios: [1, 2] },
  { label: "2/1", ratios: [2, 1] },
  { label: "1/1/1", ratios: [1, 1, 1] },
  { label: "1/2/1", ratios: [1, 2, 1] },
  { label: "1/1/1/1", ratios: [1, 1, 1, 1] },
  { label: "1/1/1/1/1", ratios: [1, 1, 1, 1, 1] },
];

export const Column = Node.create({
  name: "column",
  content: "block+",
  isolating: true,
  parseHTML: () => [{ tag: 'div[data-type="column"]' }],
  renderHTML: ({ HTMLAttributes }) => [
    "div",
    mergeAttributes(HTMLAttributes, { "data-type": "column", class: "blog-col" }),
    0,
  ],
});

export const Columns = Node.create({
  name: "columns",
  group: "block",
  content: "column+",
  defining: true,
  draggable: true,
  addAttributes() {
    return {
      cols: {
        default: "1fr 1fr",
        parseHTML: (el) => el.getAttribute("data-cols") || "1fr 1fr",
        renderHTML: (attrs) => ({
          "data-cols": attrs.cols,
          style: `--cols: ${attrs.cols}`,
        }),
      },
    };
  },
  parseHTML: () => [{ tag: 'div[data-type="columns"]' }],
  renderHTML: ({ HTMLAttributes }) => [
    "div",
    mergeAttributes(HTMLAttributes, { "data-type": "columns", class: "blog-grid" }),
    0,
  ],
});

export const Box = Node.create({
  name: "box",
  group: "block",
  content: "block+",
  defining: true,
  draggable: true,
  addAttributes() {
    return {
      variant: {
        default: "info",
        parseHTML: (el) => el.getAttribute("data-variant") || "info",
        renderHTML: (attrs) => ({ "data-variant": attrs.variant }),
      },
    };
  },
  parseHTML: () => [{ tag: 'div[data-type="box"]' }],
  renderHTML: ({ HTMLAttributes }) => [
    "div",
    mergeAttributes(HTMLAttributes, { "data-type": "box", class: "blog-box" }),
    0,
  ],
});

export const columnsJSON = (ratios: number[]) => ({
  type: "columns",
  attrs: { cols: ratios.map((r) => `${r}fr`).join(" ") },
  content: ratios.map(() => ({
    type: "column",
    content: [{ type: "paragraph" }],
  })),
});

export const boxJSON = () => ({
  type: "box",
  content: [{ type: "paragraph" }],
});

export const columnsHTML = (ratios: number[]) =>
  `<div data-type="columns" data-cols="${ratios.map((r) => `${r}fr`).join(" ")}">${ratios
    .map((_, i) => `<div data-type="column"><p>Coluna ${i + 1}</p></div>`)
    .join("")}</div><p></p>`;

export const boxHTML = () => `<div data-type="box"><p>Escreva seu destaque aqui...</p></div><p></p>`;

const col = (inner: string) => `<div data-type="column">${inner}</div>`;
const grid = (cols: string, inner: string[]) =>
  `<div data-type="columns" data-cols="${cols}">${inner.map(col).join("")}</div><p></p>`;
const box = (variant: string, inner: string) =>
  `<div data-type="box" data-variant="${variant}">${inner}</div><p></p>`;
const IMG = `<p><em>Clique aqui e use o botão de imagem da barra</em></p>`;

export const BLOCK_LIBRARY: { key: string; label: string; group: string; html: string }[] = [
  { key: "img-text", group: "Layout", label: "Imagem + texto", html: grid("1fr 1fr", [IMG, "<h3>Título</h3><p>Explique a ideia ao lado da imagem.</p>"]) },
  { key: "text-img", group: "Layout", label: "Texto + imagem", html: grid("1fr 1fr", ["<h3>Título</h3><p>Explique a ideia ao lado da imagem.</p>", IMG]) },
  { key: "two", group: "Layout", label: "2 colunas", html: grid("1fr 1fr", ["<p>Coluna 1</p>", "<p>Coluna 2</p>"]) },
  { key: "three", group: "Layout", label: "3 colunas", html: grid("1fr 1fr 1fr", ["<p>Coluna 1</p>", "<p>Coluna 2</p>", "<p>Coluna 3</p>"]) },
  { key: "cards", group: "Layout", label: "3 cards", html: grid("1fr 1fr 1fr", [1, 2, 3].map((i) => box("card", `<h3>Item ${i}</h3><p>Descrição curta.</p>`).replace("<p></p>", ""))) },
  { key: "gallery", group: "Layout", label: "Galeria", html: grid("1fr 1fr 1fr", [IMG, IMG, IMG]) },
  { key: "stats", group: "Destaques", label: "Números", html: grid("1fr 1fr 1fr", ["<h2>+120%</h2><p>Resultado 1</p>", "<h2>3x</h2><p>Resultado 2</p>", "<h2>48h</h2><p>Resultado 3</p>"]) },
  { key: "tip", group: "Destaques", label: "Dica", html: box("tip", "<p><strong>Dica:</strong> escreva aqui.</p>") },
  { key: "warn", group: "Destaques", label: "Atenção", html: box("warning", "<p><strong>Atenção:</strong> escreva aqui.</p>") },
  { key: "summary", group: "Destaques", label: "Resumo", html: box("info", "<h3>Resumo</h3><ul><li><p>Ponto principal</p></li><li><p>Outro ponto</p></li></ul>") },
  { key: "cta", group: "Destaques", label: "Chamada", html: box("cta", "<h3>Quer aplicar isso no seu negócio?</h3><p>Fale com a equipe Abillyting.</p>") },
  { key: "box", group: "Destaques", label: "Caixa livre", html: box("info", "<p>Escreva ou arraste uma grade para dentro.</p>") },
  { key: "hr", group: "Destaques", label: "Separador", html: "<hr><p></p>" },
];
